import { createMultiStyleConfigHelpers, extendTheme } from '@chakra-ui/react';

const config: string[] = [];

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(config);

const baseStyle = definePartsStyle({
  // define the part you're going to style
  overlay: {},
  dialogContainer: {
    borderRadius: 'md', // set the border radius
  },
  dialog: {
    borderRadius: 'md', // set the border radius
  },
});

const modalTheme = defineMultiStyleConfig({
  baseStyle,
});

const theme = extendTheme({
  breakpoints: {
    sm: '30em',
    md: '64em', // 1024px
    lg: '75em', // 1200px
    xl: '90em', // 1440px
  },
  colors: {
    red: {
      300: "#B10024",
    },
    yellow: {
      600: "#C3912D",
    },
    purple: {
      500: "#61374E",
    }
  },
  components: {
    Modal: modalTheme,
  },
});

export default theme;
